import React, { useCallback } from 'react'
import UsersService from 'Services/users'

import SelectVirtualOffice from '../../VirtualOffices/Forms/Select'

export default ({ user, setUser }) => {
  const addVirtualOffice = useCallback(async newVirtualOffice => {
    if (user.virtualOfficeIds.find(virtualOffice => virtualOffice.id === newVirtualOffice.id))
      return 'The virtual office has already been added'

    const virtualOffice = await UsersService.addVirtualOffices({
      userId: user.id,
      virtualOfficeIds: [newVirtualOffice.id]
    }).catch(err => err.message)

    if (typeof virtualOffice === 'string') return virtualOffice

    setUser({ ...user, virtualOfficeIds: [...user.virtualOfficeIds, newVirtualOffice] })
  })

  return <SelectVirtualOffice buttonText="Add Virtual Office" onSelect={addVirtualOffice} />
}
